export default __webpack_public_path__ + "static/media/doorIcon.da2134d2.svg";